import { useRef, type ReactNode } from 'react';

import { PageContent, PoweredByWatermark, SmConstrainedPageBody } from '@ocx/ui';

import { PullToRefresh } from '../../../components/PullToRefresh/PullToRefresh';
import { useHomeRefresh } from '../context/home-refresh.context';

type HomePageContentProps = {
  children: ReactNode;
};

export const HomePageContent = ({ children }: HomePageContentProps) => {
  const { refreshAll } = useHomeRefresh();
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <PageContent ref={contentRef}>
      <PullToRefresh onRefresh={refreshAll} scrollRef={contentRef}>
        <SmConstrainedPageBody variant="fill">
          {children}
          <PoweredByWatermark />
        </SmConstrainedPageBody>
      </PullToRefresh>
    </PageContent>
  );
};
